import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Button, Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import TextAreaField from 'components/TextAreaField';
import { Field, Form } from 'react-final-form';

import './AddMessageForContactModal.styles.scss';

type AddMessageForContactModalProps = {
  className?: string;
  onSubmit: (invitationMessage?: string) => void;
} & ModalProps;

const AddMessageForContactModal: React.ForwardRefRenderFunction<
  ModalRef,
  AddMessageForContactModalProps
> = (props, ref) => {
  const { className, onSubmit, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('add-message-for-contact-modal', className);

  const { t } = useTranslation();

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('addMessageToInvitation')}
      {...rest}
    >
      <Form
        onSubmit={({ invitationMessage }: { invitationMessage: string }) => {
          modal?.close();
          onSubmit(invitationMessage);
        }}
        render={({ handleSubmit, values: { invitationMessage } }) => (
          <form onSubmit={handleSubmit}>
            <p>{t('addMessageToInvitationDescription')}</p>

            <Field
              name="invitationMessage"
              component={TextAreaField}
              rows={6}
              label={t('invitationMessage')}
            />

            <div className="actions">
              <Button variant="link" onClick={modal?.close}>
                {t('cancel')}
              </Button>

              <Button
                variant="outline"
                onClick={() => {
                  modal?.close();
                  onSubmit();
                }}
              >
                {t('sendInvitesOnly')}
              </Button>

              <Button disabled={!invitationMessage} type="submit">
                {t('sendInvitesWithMessage')}
              </Button>
            </div>
          </form>
        )}
      />
    </Modal>
  );
};

export default forwardRef(AddMessageForContactModal);
